<template>
   <header
    :class="{ image: header.image }"
    :style="{ background: 'url(' + header.image + ')' }"
  >
    <div class="title_container" :class="{white: brightness < 125}">
        <div class="title" v-html="header.title"></div>
        <div class="subtitle" v-if="header.subtitle" v-html="header.subtitle"></div>
        <div class="text" v-html="header.text"></div>
           <div class="logos" v-if="logos">
      <a v-for="(item, index) in logos.content" target="_blank" :href="item.url" :key="index">
        <img :src="item.image" :alt="item.caption" />
      </a>
    </div>
        <div class="header_links" v-if="header.links">
          <a class="button" v-for="(item, index) in header.links" :href="item.url" :key="index">{{item.text}}</a>
        </div>
    </div>
  </header>
</template>

<script>
import moment from "moment";

export default {
  name: "Header",
  components: {},
  props: ["data", "header", "logos", "views"],
  data() {
    return {
      edit: false,
      image: null,
      title: null,
      text: null,
      brightness: null
    }
  },
  methods: {
     onInput(e) {
      console.log(e.target.innerText);
      if (e.target.innerText.includes("/")) {
        this.edit = e.target.innerText.substring(1);
       }
    },
  },
  mounted() {},
  filters: {
    formatDate: function(value) {
      return moment(String(value)).format("dddd, MMMM Do YYYY");
    },
    formatTime: function(value) {
      return moment(String(value)).format("hh:mm A");
    },
  },
  created() {
    // var self = this;
    //    this.$imageBrightness(this.header.image).then(function(result) {
    //     console.log(result);
    //     self.brightness = result;
    //   })
    // if (!this.header) {
      
    // }
  },
};
</script>
<style lang="scss">
header {
  height: auto;
  width: 100%;
  display: flex;
  @apply mx-auto flex flex-col relative justify-center items-center mb-6 leading-tight;
  .title_container {
    max-width: 1120px;
    width: 100%;
    @apply text-center flex flex-col justify-center mx-auto;
    .header_links {
      @apply inline-flex mx-auto;
      a.button {
        @apply rounded-full font-bold border px-5 py-4 mr-4;
        background: white;
        color: black;
      }
    }
  }
  &.image {
    @apply flex relative items-center justify-center  leading-tight mb-10;
    min-height: 400px;
    padding-top: 100px;
    background-size: cover !important;
    background-position: 50% 50% !important;

    @apply mb-0;
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      height: 130%;
      background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );

      width: 100%;
    }
    &:before {
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      width: 100%;
      content: "";
      position: absolute;
      top: 0;
      height: 30%;
    }
  }

  .title_container {
    color: black;
    max-width: 780px;
    position: relative;
    z-index: 9;
    width: 60%;
    @apply mb-4 mx-auto;
    text-shadow: 0 0 1px rgba(0,0,0,0.2);
    // &.white {
    //  color: white;
    //  .title {
    //     border-bottom: 1px solid rgba(255, 255, 255, 1);
    //   }
    // }
    .title {
      @apply text-4xl mb-4 pb-4 font-bold leading-tight;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .text {
     p {
       @apply text-2xl;
     }
    }
    span {
      @apply p-2 px-4 mr-3 text-base rounded-full mb-4 inline-block font-bold;
    }
  }
}

.popup {
  position: fixed; 
  top: 40px;
  left: 160px;
  z-index: 999999;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  width: 150px;
  background: #fafafa;
  @apply rounded-lg border inline-block flex flex-col;
  li {
    height: 100%;
    font-size: 13px;
    @apply flex items-center font-bold border-b py-4 px-3;
  }
}

.logos {
  width: auto;
  @apply flex items-center justify-center mx-auto mb-6;
  a {


  @apply border-r pr-4 mr-4;

    height: 45px;
  img {
height: 100%;
 width: auto;
 object-fit: contain;
}
  }
  a:last-child {
  border: none;
  @apply pr-0 mr-0;
}
}

@media only screen and (max-width: 600px) {

header {
  &.image {
  height: auto;
  }
  .title_container {
  width: 90%;
}
}
.logos {
  width: 100%;
  justify-content: center;
  a {
  @apply pr-2 mr-2;
    height: 8vw;
}
 }
}
</style>
